/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const billingProfileDataLocaleSchema = z.enum(['en-GB', 'de-DE', 'fi-FI'])

export type BillingProfileDataLocaleSchema = z.infer<typeof billingProfileDataLocaleSchema>
